import { createContext } from "react";
import { EmbeddedResourceModel } from "../Models/EmbeddedResourceModel";
import { EnumModel } from "../Models/EnumModel";
import { SharedComponentModel } from "../Models/SharedComponentModel";
import { ViewModel } from "../Models/ViewModel";

export interface IBundleContext {
  Views: ViewModel[];
  ViewById: Record<string, ViewModel>;
  EnumById: Record<string, EnumModel>;
  SharedComponentById: Record<string, SharedComponentModel>;
  Theme?: Record<string, any>;
  EmbeddedResourceById: Record<string, EmbeddedResourceModel>;
  Refresh: () => Promise<void>;
}

const BundleContext = createContext<IBundleContext>({
  Views: [],
  ViewById: {},
  EnumById: {},
  SharedComponentById: {},
  EmbeddedResourceById: {},
  Refresh: async () => {},
});
export default BundleContext;
